import * as React from 'react';

import { RequestDemandVerifySmsContainer } from '../RequestDemandVerifySmsContainer';
import { RequestDemandSuccessContainer } from '../RequestDemandSuccessContainer';
import { RequestDemandFormContainer } from '../RequestDemandFormContainer';

export const VERIFY_TITLE = 'Подтвердите номер телефона';
export const SUCCESS_TITLE = 'Спасибо, заявка отправлена!';
export const FORM_TITLE = 'Чем риелтор может вам помочь?';

export const getModalContent = (isSmsVerificationModalOpen: boolean, isSuccessModalOpen: boolean) => {
  switch (true) {
    case isSmsVerificationModalOpen:
      return {
        title: VERIFY_TITLE,
        content: <RequestDemandVerifySmsContainer />,
      };
    case isSuccessModalOpen:
      return {
        title: SUCCESS_TITLE,
        content: <RequestDemandSuccessContainer />,
      };
    default:
      return {
        title: FORM_TITLE,
        content: <RequestDemandFormContainer />,
      };
  }
};
